import { NgIf } from '@angular/common';
import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'alert-warning',
    template: `
  <div class="flex flex-col p-4 mb-3 border-s-8 border rounded-md mt-2 max-w-full border-amber-600">
        <div class="flex items-center">
            <mat-icon [svgIcon]="'heroicons_outline:information-circle'"></mat-icon>
            <span class="text-base uppercase font-semibold text-amber-600 leading-5 ml-2">{{props.label}}</span>
        </div>
        <div class="mt-2 text-base text-start justify-center text-secondary">{{props.description}}</div>
        <ng-container #fieldComponent></ng-container>
    </div>
  `,
    standalone: true,
    imports: [FormlyModule, MatIconModule]
})
export class AlertWarningComponent extends FieldWrapper implements OnInit{

  pagamentiTotali:number = 0;

  ngOnInit(): void {
    this.pagamentiTotali = this.model.pagamenti?.length || 0
  }


}
